import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppConfig } from '../app-config';
import { shouldUseAppConfigForEnvironment } from '../shared/helpers/environments';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  public inMaintenanceMode: boolean = false;

  constructor(private appConfig: AppConfig) {
    let code;
    if (shouldUseAppConfigForEnvironment(this.appConfig && this.appConfig.config && this.appConfig.config.environment)) {
      code = appConfig.config.googleTagCode;
      this.inMaintenanceMode = this.appConfig.config.maintenance;
    } else {
      code = environment.googleTagCode;
      this.inMaintenanceMode = environment.maintenance;
    }
  }
}
